import { Link } from "react-router-dom";
import { Stethoscope, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useAuth } from "@/context/AuthContext";
import NotificationsBell from "@/components/NotificationsBell";

export default function AppHeader({ subtitle }) {
  const { user, logout } = useAuth();
  return (
    <header className="sticky top-0 z-50 bg-white border-b border-slate-200">
      <div className="max-w-6xl mx-auto px-5 py-3 flex items-center justify-between gap-3">
        <Link to="/dashboard" className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-lg bg-emerald-700 flex items-center justify-center">
            <Stethoscope className="w-4 h-4 text-white" strokeWidth={2.5} />
          </div>
          <div className="flex flex-col leading-none">
            <span className="font-display text-base font-bold tracking-tight">LocumConnect</span>
            {subtitle && (
              <span className="text-[10px] uppercase tracking-[0.2em] text-slate-500 mt-1">{subtitle}</span>
            )}
          </div>
        </Link>
        <div className="flex items-center gap-1 sm:gap-2">
          {user?.is_admin && <Badge className="bg-slate-900 text-white hover:bg-slate-900">Admin</Badge>}
          <NotificationsBell />
          <span className="hidden sm:inline text-sm text-slate-600" data-testid="header-user-name">{user?.name}</span>
          <Button
            variant="ghost"
            size="sm"
            data-testid="header-logout-btn"
            onClick={logout}
            className="rounded-full"
          >
            <LogOut className="w-4 h-4 mr-1" /> <span className="hidden sm:inline">Logout</span>
          </Button>
        </div>
      </div>
    </header>
  );
}
